/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * The category it was placed under, or changed to since.
 */
export type VehicleSuspensionDtoReason = typeof VehicleSuspensionDtoReason[keyof typeof VehicleSuspensionDtoReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleSuspensionDtoReason = {
  TYRES: 'TYRES',
  INSPECTION: 'INSPECTION',
  TECHNICAL: 'TECHNICAL',
  DAMAGE: 'DAMAGE',
  ADMINISTRATIVE: 'ADMINISTRATIVE',
  OTHER: 'OTHER',
} as const;
